import Box from '@mui/material/Box';
import ImageIcon from '@mui/icons-material/Image';

/**
 * Muestra la imagen completa (sin recortar altura).
 * El ancho del contenedor se rellena con bgcolor si la foto es más estrecha.
 */
export default function CatalogProductImage({
  src,
  alt = '',
  /** Altura fija (detalle); si no, la altura sigue la proporción natural de la imagen */
  fixedHeight,
  bgcolor = 'grey.100',
  onLoad,
  onError,
}) {
  const useFrame = Boolean(fixedHeight);

  const placeholder = (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor,
        ...(useFrame
          ? { height: fixedHeight, minHeight: fixedHeight }
          : { minHeight: 140 }),
      }}
    >
      <ImageIcon sx={{ fontSize: 48, color: 'grey.300' }} />
    </Box>
  );

  if (!src) return placeholder;

  const imgSx = {
    display: 'block',
    objectFit: 'contain',
    objectPosition: 'center',
  };

  if (useFrame) {
    return (
      <Box
        sx={{
          width: '100%',
          height: fixedHeight,
          minHeight: fixedHeight,
          bgcolor,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          lineHeight: 0,
        }}
      >
        <Box
          component="img"
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onLoad={onLoad}
          onError={onError}
          sx={{
            ...imgSx,
            maxWidth: '100%',
            maxHeight: '100%',
            width: 'auto',
            height: 'auto',
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: '100%',
        bgcolor,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        lineHeight: 0,
      }}
    >
      <Box
        component="img"
        src={src}
        alt={alt}
        loading="lazy"
        decoding="async"
        onLoad={onLoad}
        onError={onError}
        sx={{
          ...imgSx,
          maxWidth: '100%',
          width: 'auto',
          height: 'auto',
        }}
      />
    </Box>
  );
}
